import { StockLink, StockPrice } from 'fin-web-components';
import type { StockNotesTabProps } from 'fin-web-components';
import type { StockLinkDetailState } from '../../components/fin-web/useStockLinkDetail';
import { INTEL_DETAIL_PANEL_STYLE } from '../intel/Config';
import { IntelStockAssessScores } from '../intel/IntelStockAssessScores';
import type { InstHotspotStockItem } from './InstHotspotType';

const STOCK_QUOTE_STYLE = INTEL_DETAIL_PANEL_STYLE.stockCard.quote;

function parsePriceText(v: string | undefined): number | null {
  if (!v?.trim() || v.trim() === '—') return null;
  const n = Number.parseFloat(v.replace(/,/g, ''));
  return Number.isFinite(n) ? n : null;
}

function parsePctText(v: string | undefined): number | null {
  if (!v?.trim() || v.trim() === '—') return null;
  const n = Number.parseFloat(v.trim().replace(/%$/, ''));
  return Number.isFinite(n) ? n : null;
}

export function InstHotspotStockCard({
  item,
  stockLinkDetail,
  requestStockDetailForLink,
  stockNotesTab,
}: {
  item: InstHotspotStockItem;
  stockLinkDetail: StockLinkDetailState;
  requestStockDetailForLink: (stockCode: string) => void;
  stockNotesTab: StockNotesTabProps;
}) {
  const code = item.stockCode.trim();
  const priceNum = parsePriceText(item.lastPrice);
  const pctNum = parsePctText(item.changePct);

  return (
    <div className="lf-intel-stock-card">
      <div className="lf-intel-stock-head">
        <StockLink
          stockCode={code}
          stockName={item.stockName}
          stockDetail={stockLinkDetail.code === code ? stockLinkDetail.data : null}
          detailLoading={stockLinkDetail.code === code && stockLinkDetail.loading}
          dayKlines={stockLinkDetail.code === code ? stockLinkDetail.dayKlines : null}
          klineLoading={stockLinkDetail.code === code && stockLinkDetail.klineLoading}
          onRequestDetail={requestStockDetailForLink}
          stockNotesTab={stockNotesTab}
        />
        <span className="lf-intel-stock-quote">
          {priceNum != null ? (
            <StockPrice
              mode="one-line"
              price={priceNum}
              change={pctNum ?? 0}
              fontSize={STOCK_QUOTE_STYLE.fontSize}
            />
          ) : (
            <span className="lf-intel-stock-quote-fallback">{item.lastPrice || '—'}</span>
          )}
        </span>
      </div>
      <div className="lf-intel-stock-reason">{item.relateReason}</div>
      <IntelStockAssessScores
        fundamentalScore={item.fundamentalScore}
        positionScore={item.positionScore}
      />
    </div>
  );
}
